document.addEventListener("DOMContentLoaded", function() {
  "use strict";
  var root = document.querySelector("[data-bfk-bundles]");
  if (!root) return;
  var pdp = root.closest("[data-ms-pdp]"), key = "bfk-book-pack-v2", products;
  try {
    products = JSON.parse(root.querySelector("[data-pack-products]").textContent);
  } catch (_) {
    root.hidden = true;
    return;
  }
  var current = products.find(function(p) {
    return p.handle === root.dataset.handle;
  });
  if (!current) {
    root.hidden = true;
    return;
  }
  var count = 1, extras = Array.from(root.querySelectorAll("[data-pack-extra]")), buttons = Array.from(root.querySelectorAll("[data-pack-count]")), status = root.querySelector("[data-pack-status]"), choices = root.querySelector("[data-pack-choices]"), active = null, continuing = false;
  function read() {
    try {
      var s = JSON.parse(sessionStorage.getItem(key));
      return s && s.expires > Date.now() && Array.isArray(s.items) ? s : null;
    } catch (_) {
      return null;
    }
  }
  function clear() {
    try {
      sessionStorage.removeItem(key);
    } catch (_) {
    }
  }
  function save(s) {
    sessionStorage.setItem(key, JSON.stringify(s));
  }
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || "es", { style: "currency", currency: root.dataset.currency || "EUR" }).format(cents / 100);
  }
  function format() {
    var id = pdp.dataset.variantId, v = current.variants.find(function(v2) {
      return String(v2.id) === id;
    });
    return v ? v.title : "Tapa dura";
  }
  function variant(p) {
    return p.variants.find(function(v) {
      return v.title === "Tapa dura" && v.available;
    });
  }
  function selected(n) {
    for (var result = [current], i = 0; i < (n === 3 ? 1 : 0); i++) result.push(products.find(function(p) {
      return p.handle === extras[i].value;
    }));
    return result;
  }
  function packVariants(n) {
    return n === 2 ? ["Tapa blanda", "Tapa dura"].map(function(title) {
      return current.variants.find(function(v) {
        return v.title === title && v.available;
      });
    }) : selected(n).map(function(p) {
      return p && (n === 1 ? p.variants.find(function(v) { return String(v.id) === pdp.dataset.variantId && v.available; }) : variant(p));
    });
  }
  function refill() {
    extras.forEach(function(select, index) {
      var old = select.value, available = products.filter(function(p) {
        return p.handle !== current.handle && variant(p) && (index === 0 || p.handle !== extras[0].value);
      });
      select.replaceChildren(), available.forEach(function(p) {
        var o = document.createElement("option");
        o.value = p.handle, o.textContent = p.title, select.appendChild(o);
      }), available.some(function(p) {
        return p.handle === old;
      }) && (select.value = old);
    });
  }
  function render() {
    buttons.forEach(function(b) {
      var n = Number(b.dataset.packCount), variants = packVariants(n), valid = variants.every(Boolean) && variants.length === (n === 1 ? 1 : 2);
      b.disabled = !valid, b.tabIndex = n === count ? 0 : -1;
      var cta = root.querySelector('[data-pack-cta="' + n + '"]');
      cta && (cta.textContent = n === count ? root.dataset.selectedLabel : root.dataset.selectLabel), b.setAttribute("aria-checked", String(n === count)), b.classList.toggle("is-selected", n === count);
      var total = valid ? variants.reduce(function(sum, v) {
        return sum + v.price;
      }, 0) : 0, rate = n === 3 ? 0.2 : n === 2 ? 0.1 : 0, final = valid ? variants.reduce(function(sum, v) {
        return sum + v.price - Math.round(v.price * rate);
      }, 0) : 0;
      root.querySelector('[data-pack-price="' + n + '"]').textContent = valid ? money(final) : "No disponible";
      var before = root.querySelector('[data-pack-before="' + n + '"]');
      before.textContent = n > 1 && valid ? money(total) : "";
    }), root.querySelector(".bfk-bundles-options").after(choices), root.querySelectorAll("[data-pack-card]").forEach(function(card) {
      card.classList.toggle("is-selected", Number(card.dataset.packCard) === count);
    });
    var thumbs = root.querySelector("[data-pack-thumbnails]");
    thumbs.replaceChildren(), thumbs.hidden = count !== 3, count === 3 && products.filter(function(p) {
      return p.handle !== current.handle && variant(p);
    }).forEach(function(p) {
      var tile = document.createElement("button");
      tile.type = "button", tile.className = "bfk-book-tile", tile.classList.toggle("is-selected", extras[0].value === p.handle), tile.setAttribute("aria-pressed", String(extras[0].value === p.handle));
      var img = document.createElement("img");
      img.src = p.image, img.alt = "", img.loading = "lazy";
      var name = document.createElement("span");
      name.textContent = p.title, tile.append(img, name), tile.addEventListener("click", function() {
        extras[0].value = p.handle, refill(), render();
      }), thumbs.appendChild(tile);
    });
    var secondImage = root.querySelector("[data-pack-second-image]"), secondBook = products.find(function(p) {
      return p.handle === extras[0].value;
    });
    secondImage && secondBook && (secondImage.src = secondBook.image), choices.hidden = count !== 3, root.querySelector("[data-pack-format]").textContent = "Los dos libros en tapa dura, con la misma foto y los mismos datos. Solo personalizas una vez.";
  }
  function resume() {
    var s = read(), token = new URLSearchParams(location.search).get("bfk_pack");
    if (!(!s || token !== s.id || !s.items[s.index] || s.items[s.index].handle !== current.handle)) {
      active = s, continuing = true;
      var plan = pdp.querySelector('[data-plan][data-variant-id="' + s.items[s.index].variant + '"]');
      plan && plan.click(), root.querySelector(".bfk-bundles-options").hidden = true, choices.hidden = true, status.hidden = false, status.textContent = "Tu pack: libro " + (s.index + 1) + " de " + s.items.length + ". Personaliza " + current.title + ".", root.querySelector("[data-pack-cancel]").hidden = false;
    }
  }
  buttons.forEach(function(b) {
    b.addEventListener("click", function(e) {
      count = Number(b.dataset.packCount), render();
      // Keep card selection available to choose the second title; the CTA starts
      // the exact same flow (and pack validation) as the main personalization CTA.
      if (e.detail === 0 || e.target.closest(".bfk-pack-cta")) {
        var opener = pdp.querySelector("[data-open-preview]");
        if (opener) opener.click();
      }
    }), b.addEventListener("keydown", function(e) {
      if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(e.key)) {
        e.preventDefault();
        var enabled = buttons.filter(function(button) {
          return !button.disabled;
        }), index = enabled.indexOf(b), direction = ["ArrowLeft", "ArrowUp"].includes(e.key) ? -1 : 1, next = e.key === "Home" ? 0 : e.key === "End" ? enabled.length - 1 : (index + direction + enabled.length) % enabled.length;
        if (enabled[next]) { count = Number(enabled[next].dataset.packCount); render(); enabled[next].focus(); }
      }
    });
  }), extras.forEach(function(s) {
    s.addEventListener("change", function() {
      refill(), render();
    });
  }), new MutationObserver(function() {
    if (refill(), render(), continuing && (choices.hidden = true, active && active.items[active.index])) {
      var expected = active.items[active.index].variant;
      if (active.kind === "titles" && pdp.dataset.variantId !== expected) {
        var fixedPlan = pdp.querySelector('[data-plan][data-variant-id="' + expected + '"]');
        if (fixedPlan) fixedPlan.click();
      }
      try {
        save(active);
      } catch (_) {
      }
    }
  }).observe(pdp, { attributes: true, attributeFilter: ["data-variant-id"] }), root.querySelector("[data-pack-cancel]").addEventListener("click", function() {
    clear(), active = null, continuing = false, root.querySelector(".bfk-bundles-options").hidden = false, status.hidden = true, this.hidden = true, count = 1, render();
  }), document.addEventListener("click", function(e) {
    if (e.target.closest("[data-open-preview]") && !continuing) {
      if (count === 1) {
        clear(), active = null;
        return;
      }
      try {
        var selectedBooks = selected(count), items = packVariants(count).map(function(v, i) {
          if (!v) throw Error("unavailable");
          return { handle: count === 2 ? current.handle : selectedBooks[i].handle, variant: String(v.id) };
        });
        active = { kind: count === 2 ? "formats" : "titles", id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8), index: 0, items, expires: Date.now() + 864e5 }, save(active);
        if (active.kind === "titles") {
          var firstPlan = pdp.querySelector('[data-plan][data-variant-id="' + active.items[0].variant + '"]');
          if (firstPlan) firstPlan.click();
        }
      } catch (_) {
        active = null, e.preventDefault(), e.stopImmediatePropagation(), status.hidden = false, status.textContent = "No hemos podido preparar el pack. Revisa los libros seleccionados o permite el almacenamiento de esta p\xE1gina.";
      }
    }
  }, true), window.bfkBundleCartItems = function(addedVariant, properties) {
    var s = active, item = { id: Number(addedVariant), quantity: 1, properties };
    if (!s || !s.items[s.index] || s.items[s.index].handle !== current.handle) return [item];
    if (s.kind === "titles" && s.items[s.index].variant !== String(addedVariant)) throw Error("pack_variant_changed");
    var props = Object.assign({}, properties, { _bfk_pack_id: s.id, _bfk_pack_kind: s.kind });
    return s.items.slice(s.index).map(function(v) {
      var book = products.find(function(p) { return p.handle === v.handle; });
      var selectedVariant = book && book.variants.find(function(variant) { return String(variant.id) === String(v.variant) && variant.available; });
      if (!selectedVariant || (s.kind === "titles" && selectedVariant.title !== "Tapa dura")) throw Error("pack_variant_unavailable");
      var bookProps = Object.assign({}, props);
      bookProps.Book = book.title;
      if (v.handle !== current.handle) {
        delete bookProps["Cover preview URL"];
      }
      return { id: Number(v.variant), quantity: 1, properties: bookProps };
    });
  }, window.bfkBundleNext = function(addedVariant) {
    try {
      var s = active || read();
      if (!s || !s.items[s.index] || s.items[s.index].handle !== current.handle) return false;
      if (s.kind === "titles" && s.items[s.index].variant !== String(addedVariant)) return false;
      clear();
      active = null;
      if (s.kind === "titles") {
        location.href = "/discount/BFKPACK2?redirect=%2Fcart";
        return true;
      }
      return false;
    } catch (_) {
      return clear(), false;
    }
  }, refill(), render(), resume(), root.hidden = false;
});
